document.addEventListener("DOMContentLoaded", function () {
  window.dispatchEvent(new Event('resize'));
  var minHeight = jQuery('.page-customer .box-wrap-content .form-vertical-wrapper').outerHeight();
  jQuery('.page-customer .box-wrap-content .box-image .box-image-wraper').css({ 'min-height': minHeight });



  jQuery('.godiva-rewards .text').each(function (index, element) {
    jQuery(element).attr('data-width', jQuery(this).width());
    if (index != 0) {
      jQuery(element).css({ 'width': '0px' });
    }
  });
  jQuery(".godiva-rewards").hover(function () {
    jQuery('.godiva-rewards .text').css({ 'width': '0px' });
    let widthE = jQuery(this).find('.text').attr('data-width');
    jQuery(this).find('.text').css({ 'width': widthE + 'px' });
  }, function () {
    //jQuery(this).find('.text').css({'width': '0px'});
  });

  jQuery(".top-bar_slider.type-slider.owl-carousel").owlCarousel({
    loop: true,
    nav: true,
    dots: false,
    margin: 0,
    autoplay: true,
    autoHeight: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    items: 1,
  });

  var listSlider = setInterval(function () {
    if (jQuery(".list").length) {
      jQuery(".list .owl-carousel").owlCarousel({
        loop: true,
        nav: true,
        dots: false,
        margin: 25,
        responsive: {
          0: {
            items: 2,
            margin: 22,
            nav: false,
          },
          600: {
            items: 3,
            stagePadding: 56,
          },
          1024: {
            items: 5,
            stagePadding: 56,
          },
        },
      });
      clearInterval(listSlider);
    }
  }, 10);
  setTimeout(function () {
    clearInterval(listSlider);
  }, 20000);
  var newsContainerSlider = setInterval(function () {
    if (jQuery(".news-container.owl-carousel").length) {
      jQuery(".news-container.owl-carousel").owlCarousel({
        nav: true,
        margin: 21,
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 2,
          },
        },
      });
      clearInterval(newsContainerSlider);
    }
  }, 10);
  setTimeout(function () {
    clearInterval(newsContainerSlider);
  }, 20000);

  if (
    jQuery(".shop-sale .product-grid-item .product-grid-item__title").length
  ) {
    jQuery(
      ".shop-sale .product-grid-item .product-grid-item__title"
    ).matchHeight();
  }

  if (jQuery(".product-grid-item .product-grid-item__info-content").length) {
    jQuery(".product-grid-item .product-grid-item__info-content").matchHeight();
  }

  if (
    jQuery(
      ".section-columns__slider .column__item__content .column__item__text"
    ).length
  ) {
    jQuery(
      ".section-columns__slider .column__item__content .column__item__text"
    ).matchHeight();
  }

  $('.product__form__errors-custom .errors__button-close').click(function () {
    $(this).closest('.product__form__errors-custom').removeClass('is-visible')
  });
});
